import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { OnboardingService } from 'src/app/services/onboarding.service';
import { ValidateDiariesPageComponent } from '../validate-diaries-page/validate-diaries-page.component';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { LandingMainPageEvent } from 'src/app/models/events/landingMainPageEvent.model';
import { AgentModel } from 'src/app/models/agent.Model';
import { AuthService } from 'src/app/services/auth.service';
import { EventService } from 'src/app/services/event.service';

import { SignalrService } from 'src/app/services/signalr.service';

import { ActivatedRoute } from '@angular/router';
import { UploadedDiariesModel } from 'src/app/models/uploadedDiaries.Model';
import { Authorization } from 'src/app/models/authorization.model';
import { agentAssignmentEvent } from 'src/app/models/events/agentAssignmentEvent.model';
import { SearchNoMatchUserComponent } from '../../components/search-no-match-user/search-no-match-user.component';
import { DownloadNBPackComponent } from '../../components/download-nb-pack/download-nb-pack.component';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DatePipe } from '@angular/common';
import { OrderByPipe } from '../../../pipes/orderby.pipe';

@Component({
  selector: 'app-onboarding-page',
  templateUrl: './onboarding-page.component.html',
  styleUrls: ['./onboarding-page.component.sass'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ToggleSwitchModule,
    SelectModule,
    ButtonModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    ProgressSpinnerModule,
    DatePipe,
    OrderByPipe,
  ],
})
export class OnboardingPageComponent implements OnInit {
  allItems: UploadedDiariesModel[] = [];
  filteredItems: UploadedDiariesModel[] = [];
  userLoggedIn: any;
  assignedItems: UploadedDiariesModel[] = [];
  unassignedItems: UploadedDiariesModel[] = [];
  authorization: Authorization = new Authorization();

  constructor(
    private authService: AuthService,
    private onboardingService: OnboardingService,
    private eventService: EventService,
    private dialogService: DialogService,
    private fb: FormBuilder,
    private graph: AuthService,
    private signalRService: SignalrService,
    private route: ActivatedRoute
  ) {}

  /** Table rows (replaces MatTableDataSource) and checkbox selection
   *  (replaces the CDK SelectionModel). */
  rows: UploadedDiariesModel[] = [];
  selectedRows: UploadedDiariesModel[] = [];
  searchValue!: string;
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  agents: any[] = [];
  agentsSelected: any;
  isAssignModeOn: boolean = false;
  isDisplayingOnlyUnassigned = false;
  assignedIsChecked = false;
  onboardingForm = this.fb.group({
    policyCode: [''],
  });

  ngOnInit(): void {
    this.authorization = this.route.snapshot.data['authorization'];

    if (this.authorization.authorizedAdminAgent) this.isAssignModeOn = true;
    else this.isAssignModeOn = false;

    this.userLoggedIn = this.authService.getUserDetail();

    this.graph.getGroupUserDetail().subscribe({
      next: (x) => {
        this.agents = x.value;
      },
      error: (e) => {
        console.error(e);
      },
    });
    this.signalRService.AllFeedObservable?.subscribe({
      next: (res: UploadedDiariesModel[]) => {
        this.listUploadedDiariesHub(res);
      },
    });
  }

  openDialog(): void {
    this.dialogService.open(SearchNoMatchUserComponent, {
      height: '600px',
      width: '1200px',
      modal: true,
      showHeader: false,
      dismissableMask: true,
    });
  }

  openDownloadNBPackDialog(): void {
    this.dialogService.open(DownloadNBPackComponent, {
      width: '450px',
      modal: true,
      showHeader: false,
      dismissableMask: true,
    });
  }

  listUploadedDiariesHub(diaries: UploadedDiariesModel[]) {
    let newItems: UploadedDiariesModel[] = [];
    let removedItems: UploadedDiariesModel[] = [];
    let existentItems: UploadedDiariesModel[] = [];

    if (this.allItems.length == 0) {
      this.allItems.push(...diaries);
    } else {
      diaries.forEach((x) => {
        let auxItem = this.allItems.find((a) => a.policyCode === x.policyCode);

        if (auxItem != undefined && auxItem != null) {
          auxItem.agentEmail = x.agentEmail;
          auxItem.agentName = x.agentName;
          auxItem.dateUploaded = x.dateUploaded;
          auxItem.dateAssigned = x.dateAssigned;
          auxItem.diaryTotal = x.diaryTotal;

          existentItems.push(auxItem);
        } else newItems.push(x);
      });

      this.allItems.forEach((a) => {
        let auxItem = diaries.filter((x) => x.policyCode == a.policyCode);

        if (auxItem.length === 0) removedItems.push(a);
      });

      this.allItems.push(...newItems);
      this.allItems = this.allItems.filter((x) => !removedItems.includes(x));

      existentItems.forEach((existent) => {
        let item = this.allItems.filter(
          (x) => x.policyCode === existent.policyCode
        )[0];

        if (item != undefined) {
          item.agentEmail = existent.agentEmail;
          item.dateAssigned = existent.dateAssigned;
          item.diaryTotal = existent.diaryTotal;
        }
      });
    }

    this.configureView();

    this.isLoadingResults = false;
  }

  configureView() {
    if (
      this.authorization.authorizedAdminIT ||
      this.authorization.authorizedAdminAgent
    ) {
      if (this.isDisplayingOnlyUnassigned) {
        this.filteredItems = this.allItems.filter((x) => !x.agentEmail);
        this.rows = [...this.filteredItems];
      } else {
        this.rows = [...this.allItems];
      }
    } else {
      this.filteredItems = this.allItems.filter(
        (x) => x.agentEmail === this.userLoggedIn.username
      );

      this.rows = [...this.filteredItems];
    }
  }

  getPolicyDetails(policyCode: string, agentEmail: string, dataUploaded: any) {
    debugger;
    const dialogRef = this.dialogService.open(ValidateDiariesPageComponent, {
      height: 'calc(100vh - 35px)',
      width: '90dvw',
      modal: true,
      showHeader: false,
      closable: false,
      closeOnEscape: false,
      contentStyle: { height: '100%', padding: '0', overflow: 'hidden' },
      data: {
        policyCode: policyCode,
        dateAssigned: dataUploaded,
        agentEmailAssigned: agentEmail,
      },
    });
    dialogRef?.onClose.subscribe((res) => {
      if (res?.isUploadedToRelay) this.listUploadedDiaries();
    });
  }

  listUploadedDiaries() {
    var user = this.authService.getUserDetail();
    let event = <LandingMainPageEvent>{};
    this.isLoadingResults = true;
    this.onboardingService.listUploadedDiaries().subscribe({
      next: (res) => {
        this.unassignedItems = res;

        event = <LandingMainPageEvent>{
          sessionId: sessionStorage.getItem('sessionId'),
          agent: <AgentModel>{
            name: user?.name,
            email: user?.username,
          },
          policies: res,
          datetimeLogin: new Date().toDateString(),
          errorMessage: '',
        };

        this.isLoadingResults = false;

        this.eventService.landingMaingPageEvent(event);
      },
      error: (error) => {
        event.errorMessage = error.message;
        this.isLoadingResults = false;
        this.eventService.landingMaingPageEvent(event);
      },
    });
  }

  setAgentsSelected() {
    let selected = this.selectedRows;
    selected.map((x) => {
      x.agentEmail = this.agentsSelected.userPrincipalName;
      x.agentName = this.agentsSelected.displayName;
      x.dateAssigned = new Date();
    });

    if (this.isDisplayingOnlyUnassigned) {
      this.assignedItems.push(...selected);
      this.rows = this.rows.filter((x) => !this.assignedItems.includes(x));
    }

    this.selectedRows = [];

    if (selected.length > 0) {
      this.onboardingService.saveAssignedTask(selected).subscribe((res) => {
        let policies = selected.map((x) => {
          return {
            policyCode: x.policyCode,
            dateUploaded: x.dateUploaded,
          };
        });

        let assignment = <agentAssignmentEvent>{
          sessionId: sessionStorage.getItem('sessionId'),
          policies: policies,
          leadEmail: this.userLoggedIn.username,
          agentAssignedEmail: selected.map((x) => x.agentEmail)[0],
          eventTime: new Date(),
        };

        this.eventService.assignTaskEvent(assignment);
      });
    }
  }

  filterUnassignedOnly() {
    this.isDisplayingOnlyUnassigned = !this.isDisplayingOnlyUnassigned;

    this.configureView();
  }

  searchByPolicyCode() {
    let policyCode =
      this.onboardingForm.controls?.policyCode.value?.toUpperCase() ?? '';

    if (policyCode) {
      this.rows = this.allItems.filter((x) => x.policyCode === policyCode);
    } else {
      this.configureView();
    }
  }

  getSelectedAmount() {
    return this.selectedRows.length;
  }
}
